import directionsJson from '../../../data/directions.json';
import iconsSprite from '../../img/icons/directions.svg';

export const ALL_DIRECTIONS = directionsJson;
export const DIRECTIONS_BY_ID = Object.fromEntries(directionsJson.map(d => [d.id, d]));
export const APPLIANCE_DIRECTIONS = directionsJson.filter(d => d.category === 'appl');
export { iconsSprite };
